import { toast } from "react-toastify";
import axiosHelper from "./axios-helper";

export const categoryEnum = (cb) => {
  console.log("categoryEnum çekiliyor");
  axiosHelper
    .get("/category/get")
    .then((response) => {
      cb(response.data);
    })
    .catch((error) => {
      axiosHelper.handleError(error, "Failed to fetch categories");
    });
};

export const getGameList = (c, cb) => {
  console.log("gameList çekiliyor");
  axiosHelper
    .get("/game/games?c=" + c)
    .then((response) => {
      cb(response.data);
    })
    .catch((error) => {
      axiosHelper.handleError(error, "Failed to fetch games");
    });
};

export const getEnumName = (list, id) => {
  return list?.find((a) => {
    return a._id === id;
  })?.name;
};
